import type * as React from 'react';

import { useHost } from '@xing-com/crate-xinglet';

import { PlayerSkeleton } from './player-skeleton';

type PlayerConfigurationProps = Record<string, unknown> & {
  isStory?: boolean;
  autostart?: boolean;
  mute?: boolean;
  preload?: boolean;
};

export type PlayerApi = {
  pause?: (
    state?: string,
    respectingAutoplaySettings?: boolean
  ) => Promise<void> | void;
  play?: (state?: string) => Promise<void> | void;
  setMute?: (state?: string) => void;
  setVolume?: (volume: number) => void;
};

export type PlayerProps = {
  id: string;
  section: string;
  posterImage?: string;
  trackingExtraFields?: Record<string, unknown>;
  configuration?: PlayerConfigurationProps;
  actions?: (playerApi: PlayerApi) => void;
  onReady?: () => void;
  onStart?: () => void;
  onMute?: () => void;
  onPlay?: () => void;
  onPause?: () => void;
  onComplete?: () => void;
  onEncodingEnd?: () => void;
  onError?: () => void;
};

export const Player: React.VFC<PlayerProps> = ({
  configuration,
  ...propsRest
}) => {
  const { XingletLoader } = useHost();
  const { isStory } = configuration ?? {};

  return (
    <XingletLoader
      name="@xing-com/crate-video-player-xinglet"
      fallback={<PlayerSkeleton isStory={isStory} />}
      {...(configuration && { configuration })}
      {...propsRest}
    />
  );
};
